<template>
  <section>
    <div class="row">
      <PublicHeader :title="title">
        <slot name="header-slot"></slot>
      </PublicHeader>
    </div>
    <div class="container">
      <Breadcrumb :links="breadcrumb" />
      <div class="row" v-if="mediaEspera >= 0">
        <div class="col-xs-12">
          <h3>Lista de solicitações</h3>
          <p class="font-lg">
            Tempo médio para agendamento de {{ mediaEspera }} dias*.
          </p>
          <p class="subtitulo">
            * Com base nos agendamentos dos últimos 6 meses
          </p>
        </div>
      </div>
      <InputCartaoSUS
        v-model="numeroCartao.espera"
        :id="'filtro_espera'"
        :carregando="carregando.espera"
        @click="getByCartao('espera')"
      />
      <ListaFilaEspera :carregando="carregando.espera" :items="dados.espera" />
      <div class="row">
        <div class="col-xs-12">
          <h3>Agendados</h3>
        </div>
      </div>
      <InputCartaoSUS
        v-model="numeroCartao.agendados"
        :id="'filtro_agendados'"
        :carregando="carregando.agendados"
        @click="getByCartao('agendados')"
      />
      <ListaFilaAgendados
        :carregando="carregando.agendados"
        :items="dados.agendados"
      />
    </div>
  </section>
</template>

<script>
import { PublicHeader, Breadcrumb, NoApiTable as DataTable } from '../common'
import { request } from '../../request'
import { getGravidadeClass, fields } from './datatableFields'
import ListaFilaAgendados from './ListaFilaAgendados'
import InputCartaoSUS from './InputCartaoSUS'
import ListaFilaEspera from './ListaFilaEspera'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    DataTable,
    ListaFilaAgendados,
    InputCartaoSUS,
    ListaFilaEspera
  },
  props: {
    title: {
      type: String,
      required: true
    },
    termoConsulta: {
      type: String,
      required: true
    },
    breadcrumb: {
      type: Array,
      required: true
    },
    urls: {
      type: Object,
      default: () => ({ espera: '', agendados: '' })
    },
    tipo: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      carregando: {
        espera: false,
        agendados: false,
        media: false
      },
      numeroCartao: {
        espera: '',
        agendados: ''
      },
      lista: {
        espera: [],
        agendados: []
      },
      listaOriginal: {
        espera: [],
        agendados: []
      },
      fields,
      mediaEspera: -1
    }
  },
  created() {
    this.getLista('espera')
    this.getLista('agendados')
    this.getMediaEspera()
  },
  methods: {
    getGravidadeClass,
    toggleLoading(key) {
      this.carregando[key] = !this.carregando[key]
    },
    getLista(key) {
      this.toggleLoading(key)
      request
        .get(this.urls[key], {
          params: {
            consulta: this.termoConsulta,
            cartao: this.numeroCartao[key]
          }
        })
        .then(response => {
          const { data } = response

          this.lista[key] = data

          if (!this.numeroCartao[key]) {
            this.listaOriginal[key] = [...this.lista[key]]
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$toastr.e(
            `Houve um errro ao carregar a lista de ${key}. Atualize a página e tente novamente`
          )
        })
        .finally(() => this.toggleLoading(key))
    },
    getByCartao(key) {
      if (this.numeroCartao[key]) {
        this.getLista(key)
      } else {
        this.lista[key] = [...this.listaOriginal[key]]
      }
    },
    getMediaEspera() {
      this.toggleLoading(`espera`)
      request
        .get(`/procedimentos-saude/${this.tipo}/media-dias`, {
          params: {
            [this.tipo]: [this.termoConsulta]
          }
        })
        .then(response => {
          const [first] = response.data

          if (first) {
            this.mediaEspera = Number(first.media).toFixed(0)
          }
        })
        .catch(error => {
          this.$toastr.e(
            'Houve um erro ao calcular o tempo médio para agendamento. Tente novamente mais tarde'
          )
        })
        .finally(() => {
          this.toggleLoading(`espera`)
        })
    }
  },
  computed: {
    dados() {
      return this.lista
    }
  }
}
</script>

<style scoped src="./datatable.css"></style>



// WEBPACK FOOTER //
// src/components/ProcedimentosSaude/index.vue